import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';

import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-promoteurs-nabeul',
  templateUrl: './promoteurs-nabeul.component.html',
  styleUrls: ['./promoteurs-nabeul.component.scss']
})
export class PromoteursNabeulComponent implements OnInit {

  public AgenciesTunis: any
  public lengthBoutique:any
  public testArraySort: any
  responsiveOptions
  @ViewChild('agencyForm', { static: false })
  agencyForm: NgForm;
  closeResult = '';
  search_name1:any;
  p: Number = 1;
  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any
  public search: string  = ''
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  lengthSociete=10;
  totalSociete : any;
  arrays: any[] = [];
  tempArray: any[] = [];
  newArray: any[] = []

  constructor(private agencieService: AgenciesService,
    private searchService: SearchService) { }

  ngOnInit(): void {
    this.getagencesNabeul();
  }
  getagencesNabeul() {
    this.agencieService.getAgencieNabeul().subscribe((data: any) => {
      this.AgenciesTunis = data;
      console.log("liste des agences en tunis", this.AgenciesTunis);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.AgenciesTunis.filter((agencie: any) => {
        return agencie.region === 'Nabeul';
        this.performSearch(); // Filtre uniquement les promoteurs ayant la région "Tunis"
      });
        
    });
  }



cancelEdit() {
  this.isEditMode = false;
  this.agencyForm.resetForm();
}

deleteAgencies(agencie,i) {
  Swal.fire({
    title: "Êtes-vous sûr(e) ?",
    text: "Vous ne pourrez pas revenir en arrière !",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimez-le."
  }).then((result) => {
    if (result.isConfirmed) {
      this.agencieService.deleteItem(agencie.id).subscribe((response: any) => {
        console.log(this.dataSource.data);
        // this.AgenciesTunis.splice(i,1)

        // If you want to show a success message after the deletion, use another Swal.fire here
        Swal.fire({
          title: "Supprimé!",
          text: "Votre agence a été supprimée.",
          icon: "success"
        });
        // Fetch the updated data after deletion
       
      }); setTimeout(() => {
          this.getagencesNabeul();
        }, 500);
      
    }
  });
}
public changePage(){
  this.lengthSociete=this.lengthSociete+10;
}
// Méthode pour effectuer la recherche
performSearch() {
  this.AgenciesTunis = this.searchService.search(this.AgenciesTunis, this.search);
}
}